import type { RootState } from 'store'
import type { ActionTree } from 'vuex'
import { ProjectService } from '../service'
import { GET_LIST_PROJECTS } from './types'
import type { ProjectState } from './types'
import orderBy from 'lodash/orderBy'
import type { IProjectForm, IProjectSearchParams } from 'interfaces'

const projectService = new ProjectService()

export const actions: ActionTree<ProjectState, RootState> = {
  async actGetListProjects({ commit, rootState }, params: IProjectSearchParams) {
    const divisions = rootState?.division.divisions ?? []
    return projectService.getListProjects(params).then((projects) => {
      const transform = orderBy(
        projects.map((p) => ({
          ...p,
          division: divisions.find((d: DivisionModel) => d.id === p.divisionId),
        })),
        [(pj) => new Date(pj.updatedAt)],
        ['desc'],
      )
      commit(GET_LIST_PROJECTS, transform)
      return transform
    })
  },
  actCreateProject(_, params: IProjectForm) {
    return projectService.createProject(params)
  },
  actUpdateProject(_, params: IProjectForm) {
    return projectService.updateProject(params)
  },
  actDeleteProject(_, params: { id: string; company: string }) {
    return projectService.deleteProject(params.id, params.company)
  },
  async actGetProjectByIds({ commit }, params: { company: string; projectIds: string }) {
    return projectService.getProjectByIds(params.company, params.projectIds).then((projects) => {
      commit(GET_LIST_PROJECTS, projects)
      return projects
    })
  },
}
